import React, { useContext, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { Sun, Moon, Menu, X } from 'lucide-react';
import { ThemeContext } from '../pages/_app';
import { navItems } from '../data/siteData';

const Navbar = () => {
  const { theme, themeToggler, activeSection, setActiveSection } = useContext(ThemeContext);
  const { pathname, hash } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname, hash]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      if (pathname !== '/') return;
      const sections = ['home', 'expertise', 'projects', 'contact'];
      const current = sections.filter(id => {
        const section = document.getElementById(id);
        return section && section.getBoundingClientRect().top <= 140;
      }).pop();
      setActiveSection(current || 'home');
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathname, setActiveSection]);

  useEffect(() => {
    const close = event => { if (event.key === 'Escape') setIsMenuOpen(false); };
    window.addEventListener('keydown', close);
    return () => window.removeEventListener('keydown', close);
  }, []);

  const renderLink = (item, mobile = false) => {
    const active = item.type === 'route' ? pathname === item.path : pathname === '/' && activeSection === item.id;
    return <Link key={item.id} to={item.path || `/#${item.id}`}
      aria-current={active ? (item.type === 'route' ? 'page' : 'location') : undefined}
      className={mobile ? `mobile-nav-item-fixed ${active ? 'mobile-nav-active-fixed' : ''}` : `nav-item-fixed ${active ? 'nav-item-active-fixed' : ''}`}
      onClick={() => {
        setIsMenuOpen(false);
        if (item.type === 'scroll') {
          setActiveSection(item.id);
          if (pathname === '/') document.getElementById(item.id)?.scrollIntoView({ behavior: 'smooth' });
        }
      }}>
      {item.label}
      {active && !mobile && <motion.div className="nav-indicator-fixed" layoutId="activeIndicator" />}
    </Link>;
  };

  return <nav className={`navbar-fixed ${scrolled ? 'scrolled' : ''}`} aria-label="Main navigation">
    <div className="navbar-container-fixed"><div className="navbar-content-fixed">
      <div className="navbar-brand-fixed"><Link to="/#home" className="brand-button-fixed" onClick={() => { setIsMenuOpen(false); document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' }); }}>Elena Nurullina</Link></div>
      <div className="navbar-nav-fixed">{navItems.map(item => renderLink(item))}</div>
      <div className="navbar-controls-fixed">
        <motion.button onClick={themeToggler} className="theme-button-fixed" aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} theme`} whileHover={{ scale: 1.1, rotate: 180 }} whileTap={{ scale: 0.9 }}>
          {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
        </motion.button>
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="mobile-button-fixed" aria-label={isMenuOpen ? 'Close navigation' : 'Open navigation'} aria-expanded={isMenuOpen} aria-controls="mobile-navigation">
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
    </div></div>
    <AnimatePresence>{isMenuOpen && <motion.div id="mobile-navigation" className="mobile-menu-fixed" initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}>
      <div className="mobile-menu-content-fixed">{navItems.map(item => renderLink(item, true))}</div>
    </motion.div>}</AnimatePresence>
  </nav>;
};
export default Navbar;
